import configureStore, { history } from 'store/configureStore'

const { store, persistor } = configureStore()

export { store, history, persistor }
export default store
